(function(){
  function buildImgEl(src, alt){
    var i=src.lastIndexOf('.');var base=src.slice(0,i);var ext=src.slice(i);
    var img=document.createElement('img');
    img.className='image-cover is-enter';
    img.alt=alt||'';
    img.decoding='async';
    img.sizes='(min-width:1700px)395px,(min-width:990px)calc((100vw - 120px)/4),(min-width:750px)calc((100vw - 80px)/2),calc(100vw/2)';
    img.src=base+'_800x'+ext;
    img.srcset=[
      base+'_180x'+ext+' 180w',
      base+'_360x'+ext+' 360w',
      base+'_540x'+ext+' 540w',
      base+'_720x'+ext+' 720w',
      base+'_800x'+ext+' 800w'
    ].join(','); 
    return img;
  }

  function crossfadeReplace(imgWrap, newSrcs, alt){
    if(!imgWrap||!newSrcs||!newSrcs.length) return;
    var current=Array.from(imgWrap.querySelectorAll('.image-cover'));
    var next=buildImgEl(newSrcs[0], alt);
    next.addEventListener('load',function(){
      requestAnimationFrame(function(){
        current.forEach(function(el){el.classList.add('is-exit')});
        next.classList.remove('is-enter');
        setTimeout(function(){current.forEach(function(el){el.remove()})},300);
      });
    },{once:true});
    imgWrap.appendChild(next);
    for(var k=1;k<newSrcs.length;k++){
      var extra=buildImgEl(newSrcs[k], alt);
      extra.classList.remove('is-enter');
      extra.classList.add('hide-hover');
      imgWrap.appendChild(extra);
    }
  }

  var _applySwatch=window.applySwatch;
  window.applySwatch=async function(card, swatchEl){
    if(!card||!swatchEl) return;
    var swatchColor=swatchEl.getAttribute('data-color');
    var productHandle=card.getAttribute('data-product-handle');
    var url='/products/'+productHandle+'.js';
    var imgWrap=card.querySelector('.product-card__image .image-container');
    var colorLabel=card.querySelector('.product-card__variant-color');
    var links=card.querySelectorAll('.product-card__link');
    var data=await fetch(url).then(function(r){return r.json()}).catch(function(){return null});
    if(!data) return;
    var variant=(data.variants||[]).find(function(v){return v.option1===swatchColor&&v.featured_image&&v.featured_image.src});
    if(!variant) return;
    card.querySelectorAll('.color-swatch').forEach(function(el){el.classList.remove('active')});
    swatchEl.classList.add('active');
    if(colorLabel) colorLabel.textContent=swatchColor;
    links.forEach(function(link){
      try{var u=new URL(link.href,window.location.origin);u.searchParams.set('variant',variant.id);link.href=u.pathname+u.search;}catch(_){}
    });
    if(imgWrap){
      var list=[variant.featured_image.src];
      (data.media||[]).forEach(function(m){
        if(m.media_type==='image'&&m.alt===swatchColor&&(!variant.featured_media||m.id!==variant.featured_media.id)) list.push(m.src);
      });
      crossfadeReplace(imgWrap,list,swatchColor);
      imgWrap.scrollLeft=0;
    }
    if(location.pathname.includes('/collections')){
      var sec=card.getAttribute('data-section-id');
      if(sec){
        var colorURL=location.pathname+'?section_id='+sec+'&filter.v.option.color='+encodeURIComponent(swatchColor);
        var html=await fetch(colorURL).then(function(r){return r.text()}).catch(function(){return null});
        if(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var fresh=doc.querySelector('.product-card[data-product-handle="'+productHandle+'"]');
          var priceD=fresh&&fresh.querySelector('.product-card__price');
          var priceM=fresh&&fresh.querySelector('.product-card__price--mobile');
          var hereD=card.querySelector('.product-card__price');
          var hereM=card.querySelector('.product-card__price--mobile');
          if(hereD&&priceD) hereD.innerHTML=priceD.innerHTML;
          if(hereM&&priceM) hereM.innerHTML=priceM.innerHTML;
        }
      }
    }
  };

  function initFirstPaint(){
    document.querySelectorAll('.product-card').forEach(function(card){
      var wrap=card.querySelector('.product-card__image .image-container');
      if(!wrap) return;
      var active=card.querySelector('.color-swatch.active');
      if(!active) return;
      var first=wrap.querySelector('.image-cover');
      if(!first) return;
      var want=card.querySelector('.product-card__variant-color');
      var wantColor=active.getAttribute('data-color')||(want&&want.textContent.trim())||'';
      var currentAlt=first.alt||'';
      if(wantColor&&currentAlt.toLowerCase()!==wantColor.toLowerCase()){
        applySwatch(card,active);
      }
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initFirstPaint);
  else initFirstPaint();
})();
